import {InboundingFeeParam, ProgramParam} from "src/model/ProgramFees";
import IPSServiceOption from "src/model/IPSServiceOption";

//TODO: aggregate IPSServiceOption file into this file
// TODO: replace after string id ready
export enum InboundingRegions {
    WEST = "West",
    CENTRAL = "Central",
    EAST = "East"
}

export const InboundingOptionLabelValueMap: Record<string, string> = {
    "RC_InputLabel_Premium": IPSServiceOption.PREMIUM,
    "RC_InputLabel_DiscountedServices": IPSServiceOption.DISCOUNTED,
    "RC_InputLabel_NoFee": IPSServiceOption.NO_FEE,
}

export const InboundingOptionToLocationNumberMap: Record<string, string[]> = {
    [IPSServiceOption.PREMIUM]: ["1"],
    [IPSServiceOption.DISCOUNTED]: ["2", "3"],
    [IPSServiceOption.NO_FEE]: ["4"],
}

export const InboundingLocationNumberValueToNameMap: Record<string, string> = {
    "1": "1",
    "2": "2",
    "3": "3",
    "4": "4+"
}

export const InboundingRegionsMap: Record<string, string> = {
    "RC_Label_WestRegion": InboundingRegions.WEST,
    "RC_Label_CentralRegion": InboundingRegions.CENTRAL,
    "RC_Label_EastRegion": InboundingRegions.EAST,
}

export const DEFAULT_INBOUNDING_FEE_PARAM: InboundingFeeParam = {
    regionLocationsMap: {[InboundingRegions.WEST]: 1},
    serviceOption: IPSServiceOption.PREMIUM,
    unitToInbound: 1
};
